import axios from "axios";
import { toast } from "react-toastify";

const customAxios = axios.create({});

let _onExpired = null;
let _membershipExpiredHandled = false;

export const setExpiredHandler = (fn) => {
  _onExpired = fn;
};

function isGlobalMembershipExpired(error) {
  if (error.response?.status !== 402) return false;
  const data = error.response?.data;
  if (data?.error === "MEMBERSHIP_EXPIRED") return true;
  const msg = String(data?.message || data?.msg || "");
  return /membership has expired/i.test(msg);
}

customAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 402) {
      if (isGlobalMembershipExpired(error)) {
        // Full-screen renewal modal already covers this; avoid one toast per API call.
        if (!_membershipExpiredHandled) {
          _membershipExpiredHandled = true;
          if (_onExpired) _onExpired();
        }
      } else {
        const message =
          error.response?.data?.message ||
          error.response?.data?.msg ||
          error.response?.data?.error ||
          error.message ||
          "Payment required.";
        toast.error(message, { toastId: `http-402-${message}` });
      }
    }

    // Single-session seat ended (idle, admin release, or another logout).
    const sessionMsg = String(error.response?.data?.msg || "");
    if (
      error.response?.status === 401 &&
      /session ended/i.test(sessionMsg) &&
      typeof window !== "undefined"
    ) {
      try {
        localStorage.removeItem("futureOfTV_User");
        sessionStorage.removeItem("evalSeatBannerSeen");
      } catch {
        /* ignore */
      }
      delete customAxios.defaults.headers.common["Authorization"];
      toast.info("Session ended. Please log in again.", {
        toastId: "session-ended",
      });
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    customAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    _membershipExpiredHandled = false;
  } else {
    delete customAxios.defaults.headers.common["Authorization"];
    _membershipExpiredHandled = false;
  }
};

// Append the current auth token as a query param. Needed for browser-initiated
// downloads (<a> / window.open) that hit authenticated routes but can't send an
// Authorization header.
export const withAuthToken = (url) => {
  const header = customAxios.defaults.headers.common["Authorization"] || "";
  const token = header.replace(/^Bearer\s+/i, "");
  if (!token) return url;
  return url + (url.includes("?") ? "&" : "?") + "token=" + encodeURIComponent(token);
};
export default customAxios;
